import type { ItemDirection } from "@domain/ItemDirection";
import type { PlanView } from "@store/plan/planReducer";

const getCurrentDirections = (
  directions: ItemDirection[] | null,
  planView: PlanView,
  navigationDirectionIndex: number,
) => {
  if (!directions) {
    return [];
  }

  return planView !== "navigate"
    ? directions
    : directions.slice(navigationDirectionIndex, navigationDirectionIndex + 1);
};

export { getCurrentDirections };
